import React from 'react';
import EditOrder from './components/EditOrder';

const EditOrderWrapper = ({
  currentRow,
  onCloseOrderPopup,
  onOrderUpdated = () => {},
}) => {
  return (
    <div>
      <EditOrder
        orderInitialValues={currentRow}
        onCloseOrderPopup={onCloseOrderPopup}
        onOrderUpdated={onOrderUpdated}
      />
    </div>
  );
};

export default EditOrderWrapper;
